import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Covers the tables while a heavy re-render runs, so a slow switch reads as
 * "working" rather than "frozen". Overlaying keeps the tables mounted, which
 * preserves their sort state.
 */
const BusyOverlay = ({ busy, label, children }) => (
  <Box sx={{ position: "relative" }}>
    {busy && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          pt: 8,
          gap: 1.5,
          backgroundColor: "rgba(255, 255, 255, 0.75)",
        }}
      >
        <CircularProgress />
        {label && (
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        )}
      </Box>
    )}
    {children}
  </Box>
);

export default BusyOverlay;
